import profileSagas from "./Profile/sagas";

export default [profileSagas()];
